<template>
  <nav class="nav">
    <ul class="nav__list">
      <li v-for="route in navRoutes" :key="route.name" class="nav__item">
        <nuxt-link
          class="nav__link"
          :to="localePath(route.url)"
        >
          <span>{{ $t(route.label) }}</span>
          <icon class="nav__icon" icon="forward-ios"/>
        </nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import SETTINGS_NAV_ROUTES from '~/constants/settings-nav-routes'

export default {
  data () {
    return {
      SETTINGS_NAV_ROUTES
    }
  },

  computed: {
    ...mapGetters(['currentUser']),

    navRoutes () {
      const { nonMemberAccount } = this.currentUser.membership
      const nonMemberRoutes = ['preferences', 'logout']
      const nonMemberOnlyRoutes = ['applications']

      return SETTINGS_NAV_ROUTES.filter(({ name }) => nonMemberAccount
        ? (nonMemberRoutes.includes(name) || nonMemberOnlyRoutes.includes(name))
        : !nonMemberOnlyRoutes.includes(name))
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;
    margin: $space-060 0;
  }

  &__link {
    @include font('050');

    display: flex;
    width: 100%;
    align-content: center;
    text-decoration: none;

    &.nuxt-link-active {
      span {
        @include underline;
      }
    }

    span {
     color: $color-black;
    }
  }

  &__icon {
    margin-left: auto;
  }
}
</style>
